import { DefaultRootState } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';

export const annotationStateSelector = ({
  annotationState,
}: DefaultRootState) => annotationState;

export const annotationSelector = createSelector(
  annotationStateSelector,
  ({ annotation }) => annotation,
);

export const annotationEcgIdSelector = createSelector(
  annotationSelector,
  (annotation) => annotation?.ecgId,
);

export const annotationTaskIdSelector = createSelector(
  annotationSelector,
  (annotation) => annotation?.id,
);

export const annotationTaskSelector = createSelector(
  annotationSelector,
  (annotation) => annotation?.annotationTask,
);

export const previousAnnotationTaskSelector = createSelector(
  annotationStateSelector,
  ({ previousAnnotationTask }) => previousAnnotationTask,
);

export const annotationTaskSettingsSelector = createSelector(
  annotationTaskSelector,
  (annotationTask) => annotationTask?.settings,
);
